import { UI_CALENDAR_TOGGLE } from "../actions";
import { Action } from "../actions";

export const isCalendarOpenReducer = (
    state = false,
    action: Action,
): boolean => {
    switch (action.type) {
        case UI_CALENDAR_TOGGLE:
            return !state;
        default:
            return state;
    }
};
